import React, {
  useCallback,
  useContext,
  useLayoutEffect,
  useMemo,
  useRef,
} from "react";
import { usePreloadedQuery } from "react-relay";
import {
  TodoEditNewMainComponent,
  TodoEditNewMainComponentRef,
} from "../../TodoEdit/TodoEditNewMain/TodoEditNewMain";

import { TodoBottomSheetTitle } from "./TodoBottomSheetTitle/TodoBottomSheetTitle";
import { TodoBottomSheetStackScreenProps } from "./TodoBottomSheetStack";
import { TODO_BOTTOM_SHEET_MAIN_SCREEN_QUERY } from "./TodoBottomSheetMainScreenQuery";
import { getTodoBottomSheetScreenOptions } from "./getTodoBottomSheetScreenOptions";
import { useTodoSaveStatus } from "../../TodoEdit/TodoEditNewMain/useTodoSaveStatus";
import { TodoBottomSheetMainHeaderRight } from "./TodoBottomSheetMainHeaderRight";
import { TodoBottomSheetNavigatorContext } from "./TodoBottomSheetNavigatorContext";

export function TodoBottomSheetMain(
  props: TodoBottomSheetStackScreenProps<"main">
) {
  const data = usePreloadedQuery(
    TODO_BOTTOM_SHEET_MAIN_SCREEN_QUERY,
    props.route.params.query
  );
  const [status, setStatus] = useTodoSaveStatus();
  const { openTodoMoveToCategory, onShowFile, openProductDetail } = useContext(
    TodoBottomSheetNavigatorContext
  );
  const ref = useRef<TodoEditNewMainComponentRef>(null);

  useLayoutEffect(() => {
    props.navigation.setOptions(
      getTodoBottomSheetScreenOptions({
        title: "",
        headerLeft: "DONE",
        navigation: props.navigation,
        headerRight: data.todo?.canWrite
          ? () => (
              <TodoBottomSheetMainHeaderRight
                mode={props.route.params.mode}
                todo={data.todo ?? null}
                openTodoMoveToCategory={openTodoMoveToCategory}
              />
            )
          : undefined,
      })
    );
  }, [
    openTodoMoveToCategory,
    props.navigation,
    props.route.params.mode,
    props.route.params.todoId,
    data.todo?.canWrite,
    data.todo,
  ]);

  const openLinkProduct = useCallback(() => {
    props.navigation.navigate("linkProduct", {
      todoId: props.route.params.todoId,
    });
  }, [props.navigation, props.route.params.todoId]);

  const titleComponent = useMemo(() => {
    if (!data.todo) return null;
    return (
      <TodoBottomSheetTitle
        todo={data.todo}
        mode={props.route.params.mode}
        setStatus={setStatus}
      />
    );
  }, [data.todo, props.route.params.mode, setStatus]);

  return data.todo ? (
    <TodoEditNewMainComponent
      onShowFile={onShowFile}
      openTodo={noOp}
      highlightCamera
      todo={data.todo}
      onRequestLinkProduct={openLinkProduct}
      openProduct={openProductDetail}
      setStatus={setStatus}
      status={status}
      inBottomSheet
      TitleComponent={titleComponent}
      ref={ref}
    />
  ) : null;
}

function noOp() {
  // no-op
}
